var _defs, _rect, _line, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMcza(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#000;stroke-miterlimit:10;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 0.9,
    y: 0.9,
    width: 18.2,
    height: 18.2
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 19.1,
    y1: 0.9,
    x2: 0.9,
    y2: 19.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.57,5.57a4.73,4.73,0,0,1,3.51-1.4,4.75,4.75,0,0,1,4.17,1.88A4.22,4.22,0,0,1,15,8.18H12.64a3.26,3.26,0,0,0-.58-1.24,2.36,2.36,0,0,0-1.89-.74,2.33,2.33,0,0,0-2,1,5.13,5.13,0,0,0-.73,3,4.45,4.45,0,0,0,.77,2.87,2.44,2.44,0,0,0,2,1,2.24,2.24,0,0,0,1.87-.82,3.8,3.8,0,0,0,.59-1.32H15a5.11,5.11,0,0,1-1.56,3,4.56,4.56,0,0,1-3.23,1.17,4.86,4.86,0,0,1-3.83-1.58A6.37,6.37,0,0,1,5,10.18,6.35,6.35,0,0,1,6.57,5.57Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMcza);
export default __webpack_public_path__ + "static/media/mcza.b2b0a76ec9dddd34b9f884634d60f0db.svg";
export { ForwardRef as ReactComponent };